import type { WireResponse } from '@/shared/generated/wire';
import type { ApplicationState, Schedule, Weekday } from './types';

type ScheduleWire = WireResponse<'/app/api/schedules', 'get', 200>[number];

export function toSchedule(wire: ScheduleWire): Schedule {
  return {
    ...wire,
    id: scheduleId(wire.id),
    account_id: scheduleId(wire.account_id),
    application_state: applicationState(wire.application_state),
    bookable: wire.bookable ?? false,
    asc_required: wire.asc_required ?? false,
    date_interest: {
      ...wire.date_interest,
      accept: wire.date_interest.accept.map((range) => ({
        ...range,
        appointment_days: range.appointment_days.map((day) => weekday(day)),
      })),
    },
  };
}

function scheduleId(value: number | string): number {
  const id = Number(value);
  if (!Number.isSafeInteger(id) || id < 1) throw new Error(`Expected a positive schedule ID, received ${value}`);
  return id;
}

function applicationState(value: string | null): ApplicationState {
  switch (value) {
    case 'awaiting_booking':
    case 'booked':
    case 'awaiting_payment':
    case 'concluded': {
      return value;
    }
    default: {
      return 'unknown';
    }
  }
}

function weekday(value: string): Weekday {
  switch (value) {
    case 'monday':
    case 'tuesday':
    case 'wednesday':
    case 'thursday':
    case 'friday':
    case 'saturday':
    case 'sunday': {
      return value;
    }
    default: {
      throw new Error(`Expected a weekday, received ${value}`);
    }
  }
}
